<template>
  <b-container fluid>
    <b-row>
      <b-col offset="4" md="4" style="text-align: center">
        <img src="@/assets/ed_logo_0.png" style="height: 75%" />
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col offset="4" md="4">
        <div class="login-box-inner">
          <h5>Login</h5>
          <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem" />
          <b-row>
            <b-col>
              <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                <b-form-group
                  id="input-group-1"
                  label="Login ID:"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.userName"
                    type="text"
                    placeholder="Enter Login ID"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  id="input-group-2"
                  label="Password:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    type="password"
                    v-model="form.password"
                    placeholder="Enter Password"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="igSIP" label="SIP:" label-for="ipSIP">
                  <b-input
                    id="ipSIP"
                    ref="idSIP"
                    v-model="SIP"
                    type="number"
                    requried
                  ></b-input>
                </b-form-group>

                <b-button type="submit" variant="info" class="float-right mx-2"
                  >Login</b-button
                >
                <b-button type="reset" variant="secondary" class="float-right"
                  >Reset</b-button
                >
              </b-form>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-modal
      ref="mdlRoleProcess"
      id="mdlRoleProcess"
      @ok="handleOk"
      @shown="focusElement"
    >
      <template #modal-header="{}">
        <h5>Select Role & Process</h5>
      </template>

      <b-form>
        <b-form-group
          id="igRole"
          label="User Role:"
          disabled
          label-for="ipRole"
        >
          <b-select
            id="ipRole"
            :options="roles"
            v-model="userRole"
            text-field="role"
            value-field="role"
          ></b-select>
        </b-form-group>
        <b-form-group id="igProcess" label="Process:" label-for="ipProcess">
          <b-select
            id="ipProcess"
            ref="idProcess"
            :options="processes"
            v-model="process"
            text-field="process"
            value-field="process"
          ></b-select>
        </b-form-group>
      </b-form>
      <template #modal-footer="{ ok, hide }">
        <b-button size="sm" variant="success" @click="ok()">OK</b-button>
        <b-button size="sm" variant="outline-secondary" @click="hide()"
          >Forget it</b-button
        >
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import apis from "@/apis";

export default {
  data() {
    return {
      show: true,
      roles: [],
      processes: [],
      form: {
        userName: "",
        password: "",
      },
      userRole: "Telecaller",
      process: "",
      SIP: 0,
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();

      let Promise = apis.login(this.form);
      Promise.then((response) => {
        if (response.status == 200) {
          response.body[0]=response.data.data[0];
          this.$store.dispatch("login", {
            user: response.body[0],
          });
          if (
            response.body[0].userRole.length > 1 ||
            response.body[0].processMapped.length > 1
          ) {
            this.roles = response.body[0].userRole;
            this.processes = response.body[0].processMapped;
            this.$refs["mdlRoleProcess"].show();
          } else {
            this.userRole = response.body[0].userRole[0];
            this.process = response.body[0].processMapped[0].process;

            this.$store.dispatch("setProcess", {
              compnayName: response.body[0].processMapped[0].companyName,
              process: this.process,
              userRole: this.userRole,
              sip: this.SIP,
            });

            this.$router.push("/dashboard");
          }
        } else {
          alert(response.message);
        }
      });
    },
    onReset(evt) {
      evt.preventDefault();
    },
    handleOk() {
      if (this.userRole != "" && this.process != "") {
        this.$store.dispatch("setProcess", {
          companyName: "",
          process: this.process,
          userRole: this.userRole,
          sip: this.SIP,
        });
        this.$router.push("/dashboard");
      }
    },
    focusElement() {
      this.$refs.idProcess.focus();
    },
  },
};
</script>
<style scoped>
.login-box-inner {
  background: #fbfbfb;
  padding: 25px 20px;
  border: solid thin #ddd;
  border-radius: 4px;
  -webkit-box-shadow: 8px 14px 14px -4px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: 8px 14px 14px -4px rgba(0, 0, 0, 0.32);
  box-shadow: 8px 14px 14px -4px rgba(0, 0, 0, 0.32);
}
</style>